import { useFeatureFlag } from 'v2/core/clients/featureFlag';
import { FeatureFlagType } from 'v2/core/clients/featureFlag/flags';

const createNewFilterFeatureFlag: FeatureFlagType = {
  name: 'create_new_filter',
  fallback: false,
};

export const useIsCreateNewFilterEnabled = () => {
  const [, isCreateNewFilterEnabled] = useFeatureFlag(
    createNewFilterFeatureFlag,
  );

  return isCreateNewFilterEnabled;
};
